// MyProvider.js
import React, { useState } from 'react';
import MyContext from './MyContext';

const MyProvider = ({ children }) => {
  const [value, setValue] = useState('sidebar-box');
  const [contentboxval,setContentbox] = useState('content-box');
  const [isloggedin,setuserloggedin] = useState(false);

  const [addtimesheettoggle,settimesheettoggle] = useState(false);
  const copyright = useState('2023 Corient Business solutions');
  const [username,setUsername] =  useState('');
  const [greeting,setGreeting] = useState('');
  const getGreeting = () => {
    const currentHour = new Date().getHours();
    let greetingmessage = '';
  
    if (currentHour >= 5 && currentHour < 12) {
      greetingmessage = 'Good morning!'; 
      // return 'Good morning!';
    } else if (currentHour >= 12 && currentHour < 17) {
      greetingmessage = 'Good afternoon!';
      // return 'Good afternoon!';
    } else {
      greetingmessage = 'Good evening!';
      // return 'Good evening!';
    }
    setGreeting(greetingmessage);
  };

  const setUserdata = (value) =>{
    setUsername(value);
  }

  const openSidebar = (newValue) => {
    setValue(newValue);
  };

  const contentBox = (newValue) =>{
    setContentbox(newValue);  
  };

  const updateuserloggedinstatus = (value) =>{
    setuserloggedin(value);
  }

  const addtimesheettogglefun = (value) =>{
    settimesheettoggle(value);   
  }

  return (
    <MyContext.Provider value={{ value, openSidebar,contentboxval,contentBox,isloggedin,updateuserloggedinstatus,copyright,username,setUserdata,greeting,getGreeting,addtimesheettoggle,addtimesheettogglefun}}>
      {children}
    </MyContext.Provider>
  );
};

export default MyProvider;
